export const BOOLEAN_OPTIONS = [
  { label: "Yes", value: true },
  { label: "No", value: false }
];

export const ETHNIC_GROUPS = [
  { header: "White" },
  { label: "English / Welsh / Scottish / Northern Irish / British", id: 1 },
  { label: "Irish", id: 2 },
  { label: "Gypsy or Irish Traveller", id: 3 },
  { label: "Any other White background", id: 4 },
  { divider: true },
  { header: "Mixed / Multiple ethnic groups" },
  { label: "White and Black Caribbean", id: 5 },
  { label: "White and Black African", id: 6 },
  { label: "White and Asian", id: 7 },
  { label: "Any other Mixed / Multiple ethnic background", id: 8 },
  { divider: true },
  { header: "Asian / Asian British" },
  { label: "Indian", id: 9 },
  { label: "Pakistani", id: 10 },
  { label: "Bangladeshi", id: 11 },
  { label: "Chinese", id: 12 },
  { label: "Any other Asian background", id: 13 },
  { divider: true },
  { header: "Black / African / Caribbean / Black British" },
  { label: "African", id: 14 },
  { label: "Caribbean", id: 15 },
  { label: "Any other Black / African / Caribbean background", id: 16 },
  { divider: true },
  { header: "Other ethnic group" },
  { label: "Arab", id: 17 },
  { label: "Any other ethnic group", id: 18 },
  { label: "Prefer not to say", id: 19 }
];

export const GENDERS = ["male", "female"];

export const COMPLIANCE_NAMES = {
  DBS: "DBS",
  HCPC: "HCPC/CCW/SSSC",
  QTS: "QTS/NCTL Qualification",
  REFERENCES: "References",
  EH: "Employment History",
  RTW: "Right to Work",
  BL: "Barred List",
  FTF: "Face-To-Face Interview",
  NIN: "National Insurance Number",
  OCB: "Overseas Criminal Background",
  PT: "Prevent Training",
  POA: "Proof of Address",
  ID: "ID Verification",
  QUALIFICATIONS: "Qualifications",
  DL: "Driving License",
  ST: "Safeguarding Training",
  TPC: "Teacher Prohibition Check",
  PID: "Proof of ID",
  PRTW: "Proof of Right to Work",
  PDL: "Proof of Driving License",
  PNIN: "Proof of National Insurance Number",
  DBSC: "DBS Check"
};

export const INIT_WORKER_DATA = {
  firstName: null,
  lastName: null,
  email: null,
  phone: null,
  cv: null,
  dob: null,
  gender: "female",
  countryOfBirth: null,
  awr: false,
  dda: false,
  ethnicGroupId: null,
  isBilling: false,
  yearsReferenced: 0,
  address: {},
  company: {},
  companyAddress: {}
};

export const PERMISSIONS = {
  BASIC_DETAILS: {
    name: "name",
    email: "email",
    password: "password"
  },
  PREFERENCES: {
    contractType: "contract-type-preference",
    workingHours: "working-hours-preference",
    jobFunction: "job-function-preference",
    location: "location-preference",
    salary: "minimum-salary-preference"
  },
  MATCHING: {
    matching: "matching-enabled"
  },
  EXPERIENCE: {
    experience: "experience"
  },
  QUALIFICATIONS: {
    qualifications: "qualifications"
  },
  LANGUAGES_AND_SKILLS: {
    languages: "languages",
    skills: "skills"
  },
  CONTACT_DETAILS: {
    address: "address",
    phoneNumber: "phone-number"
  },
  CRIMINAL_CONVICTIONS: {
    criminalConvictions: "unspent-criminal-convictions"
  },
  DIVERSITY: {
    gender: "gender",
    cisgendered: "cisgendered",
    age: "dob",
    sexualOrientation: "sexual-orientation",
    ethnicity: "ethnic-origin",
    religion: "religion",
    maritalStatus: "marital-status",
    careResponsibilities: "care-responsibilities",
    disabilities: "disabled"
  },
  INTERVIEWS: {
    interviews: "interviews"
  },
  OFFERS: {
    offers: "offers"
  },
  CV: {
    cv: "cv"
  },
  ACTIVITY: {
    offers: "offers",
    interviews: "interviews",
    conversations: "conversations",
    applications: "applications"
  }
};

export const SORTING_DATA = [
  {
    default: true,
    label: "Date",
    value: "createdAt",
    options: [
      {
        value: "-",
        label: "Newest to oldest"
      },
      {
        value: "+",
        label: "Oldest to newest"
      }
    ]
  }
];

export const FILTER_GROUPS = {
  applications: "Applications",
  interviews: "Interviews",
  offers: "Offers",
  preferences: "Preferences",
  basicDetails: "Basic Details"
};

export const WORKER_FILTERS = {
  applications_status: {
    label: "Status",
    group: FILTER_GROUPS.applications
  },
  applications_created_before: {
    label: "Created Before",
    type: "date",
    group: FILTER_GROUPS.applications
  },
  applications_created_after: {
    label: "Created After",
    type: "date",
    group: FILTER_GROUPS.applications
  },
  applications_bookings: {
    label: "For Role",
    group: FILTER_GROUPS.applications
  },
  source: {
    label: "Source",
    group: FILTER_GROUPS.basicDetails
  },
  talent_pool: {
    label: "Talent Pool",
    group: FILTER_GROUPS.basicDetails
  },
  type: {
    label: "Type",
    group: FILTER_GROUPS.basicDetails
  },
  matched_with_role: {
    label: "Matched with role",
    group: FILTER_GROUPS.basicDetails
  },
  contract_type: {
    label: "Contract Type",
    group: FILTER_GROUPS.preferences
  },
  working_hours: {
    label: "Working Hours",
    group: FILTER_GROUPS.preferences
  },
  experience_functions: {
    label: "Job Function",
    group: FILTER_GROUPS.preferences
  },
  minimum_salary: {
    label: "Minimum Salary",
    type: "number",
    group: FILTER_GROUPS.preferences
  },
  offers_bookings: {
    label: "For Role",
    group: FILTER_GROUPS.offers
  },
  offers_status: {
    label: "Status",
    group: FILTER_GROUPS.offers
  },
  interviews_bookings: {
    label: "For Role",
    group: FILTER_GROUPS.interviews
  },
  interviews_date_before: {
    label: "Date Before",
    type: "date",
    group: FILTER_GROUPS.interviews
  },
  interviews_date_after: {
    label: "Date After",
    type: "date",
    group: FILTER_GROUPS.interviews
  }
};

export const CRIMINAL_CONVICTIONS_OPTIONS = [
  `Unspent conditional cautions or convictions under the Rehabilitation of Offenders Act 1974`,
  `Adult cautions (simple or conditional) or spent convictions that are not protected as defined by
   the Rehabilitation of Offenders Act 1974 (Exceptions) Order 1975 (Amendment) (England and Wales) Order 2020`
];

export const CRIMINAL_CONVICTIONS_FOOTER_TEXT = `The amendments to the Exceptions Order 1975 (2013) provide that certain spent convictions and cautions are 'protected' and are not subject to disclosure to employers, and cannot be taken into account. However, if the role requires a Disclosure and Barring Service (DBS) check the role will be exempted under the Rehabilitation of Offenders Act 1974 and as such appointment to this post will be conditional upon the receipt of a satisfactory response to a check of police records via DBS. The DBS helps employers make safer recruitment decisions and prevent unsuitable people from working with vulnerable groups, including children. It replaces the Criminal Records Bureau (CRB) and Independent Safeguarding Authority (ISA)`;
